var _mask, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailedBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 62,
    viewBox: "0 0 118 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_229_6560",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1687 24C78.709 22.2625 79 20.4152 79 18.5C79 8.28273 70.7173 0 60.5 0C50.2827 0 42 8.28273 42 18.5C42 20.4152 42.291 22.2625 42.8313 24H0V62H118V24H78.1687Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1687 24C78.709 22.2625 79 20.4152 79 18.5C79 8.28273 70.7173 0 60.5 0C50.2827 0 42 8.28273 42 18.5C42 20.4152 42.291 22.2625 42.8313 24H0V62H118V24H78.1687Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1687 24L76.2589 23.4061L75.4523 26H78.1687V24ZM42.8313 24V26H45.5477L44.7411 23.4061L42.8313 24ZM0 24V22H-2V24H0ZM0 62H-2V64H0V62ZM118 62V64H120V62H118ZM118 24H120V22H118V24ZM77 18.5C77 20.2116 76.7401 21.8588 76.2589 23.4061L80.0785 24.5939C80.6779 22.6663 81 20.6189 81 18.5H77ZM60.5 2C69.6127 2 77 9.3873 77 18.5H81C81 7.17816 71.8218 -2 60.5 -2V2ZM44 18.5C44 9.3873 51.3873 2 60.5 2V-2C49.1782 -2 40 7.17816 40 18.5H44ZM44.7411 23.4061C44.26 21.8588 44 20.2116 44 18.5H40C40 20.6189 40.3221 22.6663 40.9215 24.5939L44.7411 23.4061ZM0 26H42.8313V22H0V26ZM2 62V24H-2V62H2ZM118 60H0V64H118V60ZM116 24V62H120V24H116ZM78.1687 26H118V22H78.1687V26Z",
    fill: "white",
    mask: "url(#path-1-inside-1_229_6560)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_229_6560)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7187 18.7046L50.5858 25.3949L53.1501 28.1288L60.283 21.4386L66.9732 28.5713L69.7071 26.007L63.017 18.8743L70.151 12.1829L67.5867 9.44892L60.4526 16.1403L53.7612 9.00617L51.0272 11.5705L57.7187 18.7046Z",
    fill: "#FF7970"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_229_6560",
    x: 47.6544,
    y: 8.51767,
    width: 25.4279,
    height: 25.4277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.44278
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.46567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.351644 0 0 0 0 0.0517768 0 0 0 0 0.0517768 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_229_6560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_229_6560",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.607855,
    dy: -0.738515
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_229_6560"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedBorder);
export default __webpack_public_path__ + "static/media/failed-border.cb873721b6dd00ef57c48c95bc74f9b5.svg";
export { ForwardRef as ReactComponent };